import '../internals/custom-jquery';
import '../internals/global';
import '../internals/form-rendez-vous';


/**
 * Function utilisée sur le formulaire "Mes disponibilités"
 */

 (function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { mesDispos : {}});
    /**
     * Initialisation du formulaire
     */
    w.Kinougarde.mesDispos.initFormulaireMesDispos = function() {        
                      
        Kinougarde.mesDispos.SecurityKey =   (new RegExp("\/mes-disponibilites\/([^\/]+)\/?","g")).exec(document.location)[1];
        
        Kinougarde.RendezVous.setMessageConfirmation(Kinougarde_RendezVous.CodeEtatCandidature);        

        const initialStep = (Kinougarde_RendezVous.CodeEtatCandidature==16 || Kinougarde_RendezVous.CodeEtatCandidature==60) ? 0 : 2;

        // Valeur par défaut du formulaire        
        const dataMesDispo = Kinougarde.GetStorage("form-mesDispos");
        Kinougarde.formulaireAcf.InitFormulaire({ defaultValue : dataMesDispo, defaultStep :initialStep});
        if (typeof(dataMesDispo)!='undefined' && dataMesDispo!==null) {
            // Init des diponibilités
            jQuery('.disponibilite-table').disponibilite(dataMesDispo.dispo_lun,dataMesDispo.dispo_mar,dataMesDispo.dispo_mer,dataMesDispo.dispo_jeu,dataMesDispo.dispo_ven,dataMesDispo.dispo_sam)
        } else {
            jQuery('.disponibilite-table').disponibilite();
        }

                  
        // Capte le clic sur "Quelques heures par jour"
        jQuery('#temps_plein0').closest('.tap-bloc').on('acf-field-type-choix-click',function(e) {
            // Passe à l'étape suivante                                                
            Kinougarde.formulaireAcf.NextStep();                     
        });
        // Capte le clic sur "Temps plein"
        jQuery('#temps_plein1').closest('.tap-bloc').on('acf-field-type-choix-click',function(e) {
            // Call ajax                   
            var indexEtapeFin = jQuery(".acf-steps .step-form").index(jQuery("#step_fin"));
            Kinougarde.formulaireAcf.NextStep({'action':'ajax_postuler_complement','stepIndex' : indexEtapeFin,'data': {'securityKey' : Kinougarde.mesDispos.SecurityKey}});            
        });
        
    
        // Capte le click sur "Confirmer" de l'étape des disponibilités
        // Avant le changement d'étape
        jQuery('#step_disponibilites').on('form-step-next-change',function(event,options) {                       
            //Modifie les options par défaut qui seront utilisés pour le passage à l'étape suivante
            var indexEtapeFin = jQuery(".acf-steps .step-form").index(jQuery("#step_fin"));
            options = {'action':'ajax_postuler_complement','stepIndex' : indexEtapeFin,'data': {'securityKey' : Kinougarde.mesDispos.SecurityKey}};            
            return options;            
        });

        // Capte L'enregistrement en base du postuler "Complet" et redirige vers "Mon rendez-vous" pour les candidat prioritaire
        jQuery("#step_confirmation,#step_disponibilites").on('form-step-next-ajax-success',function(reponse, data) {            
            if (!Kinougarde.isKinougardeOpen() && Kinougarde.Postuler.CandidaturePrioritaire==true) {
                document.location.href = Kinougarde.Postuler.UrlRendezVous;
                return false;
            }
            return true;
        });

        // Capte les évènements ajax-action-success sur l'étape des disponibilités
        // Après le changement d'étape
        jQuery("#step_disponibilites").on("form-step-next-changed", function(e,reponse,data) {
            // Mémorise les données du formulaire pour une prochaine utilisation
            // se base sur le consentement de l'utilisateur
            Kinougarde.SetStorage("form-mesDispos",data);            
        });  
        
        // Mise à jour des infos de l'agence
        Kinougarde.UpdateAgence(Kinougarde_RendezVous.Agence);        
    };  
               
    
})(window);

jQuery(function() {
    try {
    if (jQuery("#section-mes-disponibilite").length>0) {               
        Kinougarde.mesDispos.initFormulaireMesDispos();        
    };   
    }     
    catch (ex) {
        console.error(ex);
    }
});